import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Dienst} from '../dienst';
import {Categorie} from '../categorie';
import {TaakType} from '../taak';

@Component({
    selector: 'zah-categorie-navigation',
    templateUrl: './categorie-navigation.component.html',
    styleUrls: ['./categorie-navigation.component.scss'],
    standalone: false
})
export class CategorieNavigationComponent implements OnInit {

  @Input()
  dienst: Dienst;
  @Input()
  opened = true;
  @Output()
  dienstenClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  stopClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  meldingenClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  signaalkaartenClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  clientFicheClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  categorieSelected: EventEmitter<[TaakType, Categorie]> = new EventEmitter<[TaakType, Categorie]>();

  private open = true;
  private selectedTaakType: TaakType;
  private selectedCategorieId: string;

  ngOnInit(): void {
    if (this.dienst.getTaakTypes().length > 0) {
      const firstTaakType = this.dienst.getTaakTypes()[0];
      const firstCategorie = this.dienst.getCategorieenByType(firstTaakType)[0];
      this.selectCategory(firstTaakType, firstCategorie);
    }
  }

  isOpen(): boolean {
    return this.open;
  }

  toggleOpen(): void {
    this.open = !this.open;
  }

  onDienstenClicked(): void {
    this.dienstenClicked.emit();
  }

  onStopClicked(): void {
    this.stopClicked.emit();
  }

  onMeldingenClicked(): void {
    this.meldingenClicked.emit();
  }

  onSignaalkaartenClicked(): void {
    this.signaalkaartenClicked.emit();
  }

  onClientFicheClicked(): void {
    this.clientFicheClicked.emit();
  }

  selectCategory(taakType: TaakType, categorie: Categorie): void {
    this.selectedTaakType = taakType;
    this.selectedCategorieId = categorie.getId();
    this.categorieSelected.emit([taakType, categorie]);
  }

  isSelected(taakType: TaakType, categorie: Categorie): boolean {
    return taakType === this.selectedTaakType
      && categorie.hasId(this.selectedCategorieId);
  }
}
